<template>
  <component :is="layout" :class="{ blur: loading }" class="animation">
    <slot />
  </component>
  <Loadings />

</template>

<script setup>
import AppLayoutDefault from '@/layouts/AppLayoutDefault'
import AppLayoutAuth from '@/layouts/AppLayoutAuth'
import Loadings from '@/components/general/loading'
import { loading } from '@/controlles/general'
import { activity } from '@/controlles/auth'
import { computed } from 'vue'
import { useRoute,useRouter } from 'vue-router'
const rt = useRoute()
const r = useRouter()

const layout = computed(() => {
  if(rt.name == 'manager-addnew-id'){return AppLayoutAuth}
  if(rt.path == '/manager/addnew/'){return r.push('/')}
  if (activity.value) {
    return AppLayoutDefault
  } else {
    return AppLayoutAuth
  }
})

</script>

<style scoped>
.animation {
  transition: 500ms;

}


</style>
